import Image from "next/image";
import React from "react";
import styles from "./upsc-mains-test-series-2023.module.css";
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
const redrightarrow = "../../assets/images/contact/redrightarrow.png";
import Link from "next/link";

const UPSC_Main_Test_Series_2023 = () => {

 const contactcontent =[
    {heading:"Class (Chennai Annanagar)", Image: pin, address:"Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040.", Image1: call, mobileno:"90030 73321", Image2: mail, mailid:"moksha@shankarias.in", direction:"Get Directions",Image3: redrightarrow, url:"https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.082454,80.204809,15z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu", url1:"https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.082454,80.204809,15z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu"},
    {heading:"Evaluation (Chennai Annanagar)", Image: pin, address:"SDV Arcade, 2nd Avenue, AB Block, Shanthi Colony, Anna nagar (soch showroom, 3rd floor) Anna Nagar, Chennai-600040.",Image1: call, mobileno:"90030 73321", Image2: mail, mailid:"moksha@shankarias.in", direction:"Get Directions",Image3: redrightarrow, url:"https://www.google.com/maps/place/13%C2%B005'04.6%22N+80%C2%B012'52.1%22E/@13.0846111,80.2144722,17z/data=!3m1!4b1!4m4!3m3!8m2!3d13.0846111!4d80.2144722?hl=en&entry=ttu", url1:"https://www.google.com/maps/place/13%C2%B005'04.6%22N+80%C2%B012'52.1%22E/@13.0846111,80.2144722,17z/data=!3m1!4b1!4m4!3m3!8m2!3d13.0846111!4d80.2144722?hl=en&entry=ttu"}
 ]

 return (
    <>
        
        <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
            <div className="row" id="optionaltest">
                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                    <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                       <ul>
                           <li className={`${styles.sectiontitle2} mb-0`}>Classes on<br/>Mains only subjects</li>                     
                       </ul>
                    </div>
                </div>

                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                    <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <ul>
                            <li className={`${styles.sectiontitle2} mb-0`}>Mains 2024<br/> test series</li>                               
                        </ul>
                    </div>
                </div>

                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                   <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <ul>
                            <li className={`${styles.sectiontitle2} mb-0`}>Books for<br/>Mains only subjects</li>                               
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="container-fluid" style={{background: '#F4F6F8 0% 0% no-repeat padding-box'}}>
            <div className="row">
                <div className="col py-5 px-0">

                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <p className={`${styles.sectiontitle}`}>Location</p>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">

                            <div className="col">
                                <div className="row">

                                {contactcontent.map((item,index)=>(
                                <div className="col-md-6 col-lg-6 col-xl-4 col-12 mb-3" key={index}>
                                        <div className={`${styles.contactbox} h-100`}>
                                            <div className={`${styles.contactboxheight} px-4 pt-4  pt-md-5`}>
                                                

                                                    <p className={`${styles.acheivername}`} style={{color:"#DB1B0D"}}>{item.heading}</p>

                                                    <div className="row">
                                                        <div className="col-1 pe-0">
                                                            <Image src={item.Image} width={14} height={14} className="img-fluid" alt="location" title="Branch Address"/>
                                                        </div>
                                                        <div className="col-11">
                                                            <p className={`${styles.acheiverrank} mb-0`}>{item.address}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row pt-3">
                                                        <div className="col-1 pe-0">
                                                            <Image src={item.Image1} width={14} height={14} className="img-fluid" alt="number icon" title="Branch Contact Number"/>
                                                        </div>
                                                        <div className="col-11">
                                                            <p className={`${styles.acheiverrank} mb-0`}><a href="tel:90030 73321" className={`${styles.mobilemaillinks}`}>{item.mobileno}</a></p>
                                                            <p className={`${styles.acheiverrank}`}><a href="tel:90030 73321" className={`${styles.mobilemaillinks}`}></a></p>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-1 pe-0">
                                                            <Image src={item.Image2} width={14} height={14} className="img-fluid" alt="email icon" title="Branch Email Address"/>
                                                        </div>
                                                        <div className="col-11">
                                                            <p className={`${styles.acheiverrank} mb-0`}><a href="mailto:enquiry@shankarias.in" className={`${styles.mobilemaillinks}`}>{item.mailid}</a></p>
                                                        </div>
                                                    </div>

                                            </div>
                                            <hr className="mb-0"/>
                                            <div className="px-4 pb-1 py-md-2">
                                                
                                                    <div className="row">
                                                            <div className="col-9 col-xl-10 align-self-center">
                                                                <Link href={item.url} target="_blank" className={`${styles.redunderline} mb-0`}>{item.direction}</Link>
                                                            </div>
                                                            <div className="col-3 col-xl-2">
                                                                <Link href={item.url1} target="_blank"><Image src={item.Image3} width={100} height={100} className={`${styles.img} img-fluid`} alt="arrow" title="Link"/></Link>
                                                            </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    ))}
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>
    )
}
export default UPSC_Main_Test_Series_2023;
